var _ = { escape: require('lodash.escape') };
module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div id="' +
__e( id ) +
'" class="booking-calendar"><div class="booking-calendar__spinner hidden" data-preload-copy="Please wait" data-reserve-timeslot-copy="Please wait while we reserve the time slot"><rm-icon class="icon--svg-spinners icon--svg-spinners--ring-resize"></rm-icon><span class="spinner_copy"></span></div><div class="booking-calendar__calendar hidden"></div><div class="booking-calendar__form hidden"><section class="rm-container-form" form="rmcp_appointment"></section><section class="rm-container-form" form="appointment_lead"></section></div><div class="booking-calendar__result hidden"></div><div class="booking-calendar__survey hidden"></div></div>';

}
return __p
};

/*
original source:

<div id="<%- id %>" class="booking-calendar">
    <div class="booking-calendar__spinner hidden"
        data-preload-copy="Please wait"
        data-reserve-timeslot-copy="Please wait while we reserve the time slot"
    >
        <rm-icon class="icon--svg-spinners icon--svg-spinners--ring-resize"></rm-icon>
        <span class="spinner_copy"></span>
    </div>
    <div class="booking-calendar__calendar hidden"></div>
    <div class="booking-calendar__form hidden">
        <section class="rm-container-form" form="rmcp_appointment"></section>
        <section class="rm-container-form" form="appointment_lead"></section>
    </div>
    <div class="booking-calendar__result hidden"></div>
    <div class="booking-calendar__survey hidden"></div>
</div>

*/
